import {ChangeDetectorRef, Component, Input, OnDestroy} from "@angular/core";
import {Subscription} from "rxjs";
import {NavigationService} from "../../orchestration/navigation.service";
import {OrderModel} from "../order.model";
import {OrderingContextModel} from "../../ordering-context/ordering-context.model";
import {OrderEvents, OrderInitiationStatus} from "../order-events";
import {RecentOrderData} from "../recent-order.service";
import {InitiatedOrderData, PaymentSurchargeData} from "../order-initiation.service";

@Component({
    selector: "woa-order-totals-panel",
    templateUrl: "order-totals-panel.component.html"
})

export class OrderTotalsPanelComponent implements OnDestroy {
    @Input() recentOrder: RecentOrderData;
    @Input() totalOnly: boolean = false;
    @Input() showZeroTip: boolean = true;
    @Input() showSavings: boolean = true;
    @Input() showPoints: boolean = true;
    @Input() canEditTip: boolean = true;

    OrderInitiationStatus = OrderInitiationStatus;
    OrderEvents = OrderEvents;

    private subscriptions: Subscription = new Subscription();

    constructor(public orderingContextModel: OrderingContextModel,
                public orderModel: OrderModel,
                private navigationService: NavigationService,
                private changeDetectorRef: ChangeDetectorRef) {
        this.subscriptions.add(OrderEvents.orderChanged$.subscribe(() => this.changeDetectorRef.detectChanges()));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    get initiatedOrder(): InitiatedOrderData {
        return this.recentOrder ? this.recentOrder.initiatedOrder : this.orderModel.initiatedOrder;
    }

    get totalItems(): number {
        return this.recentOrder ? this.recentOrder.orderInitiation.totalItems : this.orderModel.totalItems;
    }

    get tipAmount(): number {
        return !this.recentOrder ? (this.orderModel.tipAmount || 0)
            : !this.recentOrder.placedOrder.requestId ? this.recentOrder.initiatedOrder.tipAmount
                : this.recentOrder.orderPlacement.paymentAuthorisation.payWithPoints ? 0
                    : this.recentOrder.orderPlacement.paymentAuthorisation.tipAmount || 0;
    }

    get totalPayment(): number {
        return !this.recentOrder ? this.orderModel.orderTotalPayment
            : this.recentOrder.orderPlacement.paymentAuthorisation.payWithPoints ? this.recentOrder.initiatedOrder.orderTotal
                : this.recentOrder.initiatedOrder.getOrderOrderTotalWithPaymentSurcharge(PaymentSurchargeData.CREDIT_CARD_TYPE) + this.tipAmount;
    }

    get taxAmount(): number {
        return this.recentOrder ? this.recentOrder.initiatedOrder.taxIncluded : undefined;
    }

    get orderSaving(): number {
        return this.recentOrder ? 0 : this.orderModel.orderSaving;
    }

    get processingFee(): PaymentSurchargeData {
        return !this.recentOrder ? this.orderModel.initiatedOrder.getPaymentSurcharge(PaymentSurchargeData.CREDIT_CARD_TYPE)
            : this.recentOrder.orderPlacement.paymentAuthorisation.payWithPoints ? undefined
                : this.recentOrder.initiatedOrder.getPaymentSurcharge(PaymentSurchargeData.CREDIT_CARD_TYPE);
    }

    get totalLabel(): string {
        return this.orderModel.totalItems === 0 ? undefined
            : this.orderModel.totalItems === 1 ? "woa.label.order.totals.totalItems.singular"
                : "woa.label.order.totals.totalItems.plural";
    }

    get canShowPoints(): boolean {
        return this.showPoints && !this.totalOnly && !!this.initiatedOrder.points &&
            (!this.recentOrder || (this.recentOrder.orderPlacement.requestId && !this.recentOrder.orderPlacement.paymentAuthorisation.payWithPoints));
    }

    get pointsLabel(): string {
        return this.recentOrder ? "woa.label.order.totals.pointsEarned" : "woa.label.order.totals.earningPoints";
    }

    async editTip(): Promise<void> {
        if (this.canEditTip && await this.navigationService.createPage("woa-tip-selection-page")) {
            this.changeDetectorRef.detectChanges();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/order/order-totals-panel/order-totals-panel.component.ts